import React, { useState } from 'react';
import { Link } from '@material-ui/core';

const DownloadStaticFileLink = ({ children, style = {}, isChangeColor, stopChangeColor, href, name }) => {
    const [color, setColor] = useState({});
    const handleClick = (e) => {
        if (isChangeColor && JSON.stringify(color) === '{}' && !stopChangeColor) {
            setColor({ color: 'purple' });
        }
    };

    return (
        <Link
            style={{ ...style, ...color, textDecoration: 'underline' }}
            onClick={(e) => handleClick(e)}
            href={href}
            download={name}
            target={'_blank'}
            rel="noreferrer noopener"
        >
            {children}
        </Link>
    );
};

export default DownloadStaticFileLink;
